"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Paragraph;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _index = _interopRequireDefault(require("../tooltip/index.js"));
var _text = _interopRequireDefault(require("@ux/text"));
const ConditionsTooltipWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ConditionsTooltipWrapper",
  class: "core-cs9osak"
});

/**
 * Render paragraph.
 * @module Paragraph
 *
 * @param {Object} props React props
 * @param {string} props.asType ux text identifier
 * @param {number} props.size size of the text
 * @param {string} props.dataCy data-cy override
 * @param {string} props.text description text
 * @param {Object} props.tooltip tooltip object
 * @param {string} [props.className] paragraph CSS class
 * @param {string} props.tag paragraph CSS class
 * @param {string} props.itemProp Used for associating structured data properties with an item for semantic markup purposes
 * @returns {React.ReactElement} Paragraph element
 * @public
 */
function Paragraph({
  asType = 'paragraph',
  size,
  dataCy = 'paragraph',
  text,
  tooltip,
  className,
  tag,
  itemProp,
  ...rest
}) {
  if (!text) return null;
  let ParagraphTag = _text.default.p;

  // In the case html is put into a field we need to avoid creating an invalid dom structure.
  // An invalid DOM nesting structure will break SSR
  // To avoid this we need to set the tag to a div as it can accept most html elemnts as a child
  if (tag) {
    ParagraphTag = _text.default[tag] || _text.default.div;
  } else if (tooltip) {
    ParagraphTag = _text.default.div;
  } else if (/*#__PURE__*/_react.default.isValidElement(text)) {
    ParagraphTag = _text.default.div;
  }
  return /*#__PURE__*/_react.default.createElement(ParagraphTag, (0, _extends2.default)({
    as: asType,
    size: size,
    "data-cy": dataCy,
    className: className
  }, rest, {
    itemProp: itemProp
  }), text, tooltip && /*#__PURE__*/_react.default.createElement(ConditionsTooltipWrapper, {
    "data-cy": "tooltip-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_index.default, tooltip)));
}
Paragraph.propTypes = {
  asType: _propTypes.default.string,
  size: _propTypes.default.number,
  dataCy: _propTypes.default.string,
  text: _propTypes.default.node,
  tooltip: _propTypes.default.object,
  className: _propTypes.default.string,
  tag: _propTypes.default.string,
  itemProp: _propTypes.default.string
};